import 'angular-sanitize/angular-sanitize';
import { bindhtmlComponent } from './bind-html.component';
import './bind-html.scss';

export const bindHtml = angular
	.module('common.components.bindHtml', ['ngSanitize'])
	.component('bindHtml', bindhtmlComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/bind-html/bind-html.module.js